import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';

import { LearningExampleForm } from './learning-example-form/learning-example-form.component';

// Define the structure for the language-specific parts' controls
interface LanguageFormControls {
  translation: FormControl<string | null>;
  otherTranslations: FormArray<FormControl<string | null>>;
}

// Define the type for the main form group's controls
export type WordFormControls = {
  word: FormControl<string | null>;
  translation: FormControl<string | null>;
  useFrequency: FormControl<number | null>;
  respelledPhonetic: FormControl<string | null>;
  wordCategory: FormControl<string | null>;
  level: FormControl<number | null>;
  ipaPhonetic: FormControl<string | null>;
  hispanicPhonetic: FormControl<string | null>;
  examples: FormArray<FormControl<string | null>>;
  synonyms: FormArray<FormControl<string | null>>;
  definitions: FormArray<FormControl<string | null>>;
  otherTranslations: FormArray<FormControl<string | null>>;
  learningExamples: FormArray<LearningExampleForm>;
  en: FormGroup<LanguageFormControls>; // Use the controls type here
  es: FormGroup<LanguageFormControls>; // Use the controls type here
  extra: FormGroup; // Keep as generic FormGroup for flexibility
};

// Define the main form group type using the controls type
export type WordFormGroup = FormGroup<WordFormControls>;

// Type for the value of the form
export type WordFormValue = WordFormGroup['value'];

@Injectable({
  providedIn: 'root',
})
export class WordFormService {
  private formBuilder = inject(FormBuilder);

  // Update return type to the specific WordFormGroup
  public initializeForm(extensionForm: FormGroup): WordFormGroup {
    // Cast the return value to the specific type
    return this.formBuilder.group<WordFormControls>({
      // Specify controls type here
      word: this.formBuilder.control('', Validators.required),
      translation: this.formBuilder.control(''),
      useFrequency: this.formBuilder.control(1),
      respelledPhonetic: this.formBuilder.control(''),
      wordCategory: this.formBuilder.control(''),
      level: this.formBuilder.control(1),
      ipaPhonetic: this.formBuilder.control(''),
      hispanicPhonetic: this.formBuilder.control(''),
      examples: this.formBuilder.array<FormControl<string | null>>([]),
      synonyms: this.formBuilder.array<FormControl<string | null>>([]),
      definitions: this.formBuilder.array<FormControl<string | null>>([]),
      otherTranslations: this.formBuilder.array<FormControl<string | null>>([]),
      learningExamples: this.formBuilder.array<LearningExampleForm>([]),
      en: this.formBuilder.group<LanguageFormControls>({
        translation: this.formBuilder.control(''),
        otherTranslations: this.formBuilder.array<FormControl<string | null>>([]),
      }),
      es: this.formBuilder.group<LanguageFormControls>({
        translation: this.formBuilder.control(''),
        otherTranslations: this.formBuilder.array<FormControl<string | null>>([]),
      }),
      extra: extensionForm,
    });
  }
}
